import React from 'react';

// The BARE mark, following the active theme.
//
// Both sources are rendered and toggled with CSS rather than picking one in JS: a /public
// asset cannot be referenced from a CSS url() (css-loader tries to resolve it at build time
// and the build fails), and swapping `src` on a theme change flashes while the new file
// loads. The hidden one is display:none, so it stays out of the accessibility tree.
// Exported for the rare caller that wants one fixed variant rather than the theme swap
// (the holiday loader paints the navy mark on its own backdrop).
export const LOGO_LIGHT_SRC = '/img/logoset/ICON_NAVY_RED.svg';
export const LOGO_DARK_SRC = '/img/logoset/ICON_WHITE_GREY.svg';

export default function BravoLogo({ className = '', alt = 'BARE' }) {
  const classes = (variant) => ('bravo-logo bravo-logo-' + variant + ' ' + className).trim();
  return (
    <>
      <img
        className={classes('light')}
        src={LOGO_LIGHT_SRC}
        alt={alt}
      />
      <img
        className={classes('dark')}
        src={LOGO_DARK_SRC}
        alt={alt}
      />
    </>
  );
}
